<div matDialogTitle class="modal-header">
    <h3>{{ (isEditMode ? 'pages.user_modal.edit_title' : 'pages.user_modal.title') | translate }}</h3>
    <button mat-icon-button class="red-color" (click)="closeModal()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <!-- Search Section - Only show in create mode -->
        <div class="form-section" *ngIf="!isEditMode" #searchContainer>
            <mat-form-field class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ 'pages.user_modal.search_user' | translate }}</mat-label>
                <input matInput
                       formControlName="searchUser"
                       [placeholder]="'pages.user_modal.placeholder' | translate"
                       (click)="toggleSearchResults()">
                <mat-icon matSuffix class="red-color">person_search</mat-icon>
            </mat-form-field>

            <!-- Loader when searching -->
            <div *ngIf="showSearchResults && isSearching"
                 class="search-results d-flex justify-content-center align-items-center p-3">
                <mat-spinner diameter="30"></mat-spinner>
            </div>

            <!-- Search Results with visibility based on showSearchResults and not isSearching -->
            <mat-list *ngIf="showSearchResults && !isSearching && filteredUsers.length > 0"
                      class="search-results">
                <mat-list-item *ngFor="let user of filteredUsers"
                               (click)="selectUser(user)"
                               class="search-result-item">
                    {{ user.igg }} | {{ user.first_name }} {{ user.last_name }}
                </mat-list-item>
            </mat-list>
        </div>

        <!-- User Info Section -->
        <div class="row">
            <div class="col-6">
                <h3 class="section-title">{{ 'pages.user_modal.user' | translate }}</h3>

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'models.user.first_name' | translate }}</mat-label>
                    <input matInput formControlName="first_name">
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'models.user.last_name' | translate }}</mat-label>
                    <input matInput formControlName="last_name">
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'models.user.igg' | translate }}</mat-label>
                    <input matInput formControlName="igg">
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'models.user.email' | translate }}</mat-label>
                    <input matInput formControlName="email" type="email">
                </mat-form-field>
            </div>

            <div class="col-6">
                <h3 class="section-title">{{ 'pages.user_modal.role' | translate }}
                    : {{ 'pages.user_modal.select_role' | translate }}
                    <span class="required-marker">*</span>
                </h3>

                <div class="role-section">
                    <mat-radio-group formControlName="role" class="role-group">
                        <mat-radio-button *ngFor="let roleOption of roles" [value]="roleOption.value">
                            {{ roleOption.label | translate }}
                        </mat-radio-button>
                    </mat-radio-group>
                    <mat-error *ngIf="userForm.controls.role.hasError('required') && userForm.controls.role?.touched">
                        {{ 'validations.required' | translate }}
                    </mat-error>
                </div>

                <h3 class="section-title">{{ 'pages.user_modal.site_and_unities' | translate }}</h3>

                <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>{{ 'pages.user_modal.sites' | translate }}</mat-label>
                    <mat-select formControlName="sites" [multiple]="true">
                        <mat-option *ngFor="let site of sites" [value]="site.id">
                            {{ site.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                            *ngIf="userForm.controls.sites.hasError('required') && userForm.get('role')?.value !== UserRole.SUPER_ADMIN">
                        {{ 'validations.required' | translate }}
                    </mat-error>
                </mat-form-field>

                <!-- Units selection -->
                <mat-form-field appearance="outline" class="w-100 mb-2" *ngIf="userForm.get('sites')?.value?.length > 0 && isDataReady">
                    <mat-label>{{ 'pages.user_modal.units' | translate }}</mat-label>
                    <mat-select formControlName="unities" [multiple]="true" (selectionChange)="onUnitySelectionChange($event)">
                        <ng-container *ngFor="let siteId of userForm.get('sites')?.value; trackBy: trackBySiteId">
                            <mat-optgroup [label]="getSiteLabel(siteId)" *ngIf="unitiesBySite[siteId]">
                                <!-- All option for this site -->
                                <mat-option [value]="'all-' + siteId" class="all-option" (onSelectionChange)="toggleAllUnits(siteId, $event)">
                                    {{ 'pages.user_modal.all_units_in_site' | translate }}
                                </mat-option>
                                <!-- Individual units for this site -->
                                <mat-option *ngFor="let unity of unitiesBySite[siteId]; trackBy: trackByUnityId" [value]="unity.id">
                                    {{ unity.label }}
                                </mat-option>
                            </mat-optgroup>
                        </ng-container>
                    </mat-select>
                    <mat-error *ngIf="!isUnitySelectionValid() && userForm.get('role')?.value !== UserRole.SUPER_ADMIN">
                        {{ 'pages.user_modal.select_units_error' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer" align="end">
    <div class="mandatory-note">
        <span class="required-marker">*</span> {{ 'pages.user_modal.mandatory' | translate }}
    </div>
    <div>
        <button mat-button (click)="closeModal()">
            {{ 'general.actions.cancel' | translate }}
        </button>
        <button mat-raised-button
                color="primary"
                type="submit"
                [disabled]="!isFormDataComplete || isSubmitting"
                (click)="onSubmit()">
            {{ (isEditMode ? 'general.actions.update' : 'general.actions.save') | translate }}
        </button>
    </div>
</mat-dialog-actions>
